<template>
  <section id="map-filter" class="card has-background-dark has-text-light">
    <header class="card-header">
      <p class="card-header-title has-text-light">
        {{ $t('filter') }}
      </p>
    </header>
    <div class="card-content">
      <div class="field">
        <b-switch
          v-model="red"
          @input="filter"
          type="is-danger">
          {{ $t('not compliant') }}
        </b-switch>
      </div>
      <div class="field">
        <b-switch
          v-model="yellow"
          @input="filter"
          type="is-warning">
          {{ $t('not sure') }}
        </b-switch>
      </div>
      <div class="field">
        <b-switch
          v-model="green"
          @input="filter"
          type="is-success">
          {{ $t('compliant') }}
        </b-switch>
      </div>
    </div>
  </section>
</template>

<script>


export default {
  name: 'MapFilterComponent',
  data () {
    return {
      red: this.$store.getters['filter'][0],
      yellow: this.$store.getters['filter'][1],
      green: this.$store.getters['filter'][2]
    }
  },
  methods: {
    filter () {
      this.$store.dispatch('filter', {
        0: this.red,
        1: this.yellow,
        2: this.green
      })
    }
  }
}

</script>

<style lang="stylus">

#map-filter
  margin: 0px 6px 26px 6px
  label
    color: white

</style>
